module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0079.jpg?v=b56476c8";